import { Formik } from 'formik'
import * as Yup from 'yup'
import { Link, useNavigate } from 'react-router-dom'
import {
  usePostChallengeMutation,
  usePostLoginMutation,
  usePutChallengeMutation,
} from '../../api/api'
import { useEffect, useState } from 'react'
import LoadingBlocker from '../../components/LoadingSpinner/LoadingBlocker'
import Logo from '../../assets/images/logo.png'

const ChallengeView = ({ user }) => {
  const navigate = useNavigate()
  const [hasResent, setHasResent] = useState(false)
  const [putChallenge, { isLoading, error }] = usePutChallengeMutation()
  const [postChallenge, { isLoading: resendIsLoading }] =
    usePostChallengeMutation()
  const schema = Yup.object().shape({
    code: Yup.string().required('Please enter your verification code'),
  })

  useEffect(() => {
    if (user?.id) {
      navigate('/library')
    }
  }, [navigate, user?.id])

  function onSubmit(values) {
    putChallenge({ code: values.code.trim() })
  }

  function handleResendClick() {
    setHasResent(true)
    postChallenge()
      .unwrap()
      .catch(() => {
        navigate({
          pathname: '/login',
          search: '?error=code_expired',
        })
      })
  }

  return (
    <div className="flex w-full h-full items-center justify-center h-full relative overflow-hidden">
      <div className="login-bg"></div>
      <div className="w-[600px]">
        <div className="flex items-center mb-6">
          <img src={Logo} alt="Sharefolio logo" className="w-[48px]" />
          <div className="text-salmon font-heading font-bold ml-2 text-4xl pt-2">
            Sharefolio
          </div>
        </div>
        <div className="bg-gray-light p-12 rounded drop-shadow-lg mb-10 relative">
          <h2 className=" mb-2">Verification Code</h2>
          <p className="mb-6">
            Please enter the verification code that was sent to your email.
          </p>
          {hasResent && (
            <p className="p-4 my-4 bg-gray-dark rounded">
              A new code has been sent to your email address.
            </p>
          )}
          <Formik
            validationSchema={schema}
            initialValues={{ code: '' }}
            onSubmit={(values) => {
              onSubmit(values)
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
            }) => (
              <div className="login">
                {error && (
                  <div className="p-4 bg-pink-dark rounded border border-pink-error mb-4">
                    <p>
                      The verification code you entered is incorrect or has
                      expired, please try again.
                    </p>
                  </div>
                )}
                <div className="form">
                  <form noValidate onSubmit={handleSubmit}>
                    <label htmlFor="code">Verification Code</label>
                    <input
                      type="text"
                      name="code"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.code}
                      placeholder="Verification Code"
                      className="form-control inp_text"
                      id="code"
                    />
                    <p className="error">
                      {errors.code && touched.code && errors.code}
                    </p>

                    <div className="flex pt-10">
                      <div className="flex-fill">
                        <button
                          className="py-[10px] text-sm button -ml-6 font-bold bg-transparent hover:bg-gray-dark text-white-dark"
                          type="button"
                          onClick={handleResendClick}
                        >
                          Resend Code
                        </button>
                      </div>
                      <div>
                        <Link
                          className="button bg-transparent hover:bg-gray-dark text-white-dark inline-block mr-2"
                          to="/login"
                        >
                          Back
                        </Link>
                      </div>
                      <div>
                        <button
                          className="button bg-purple-light hover:bg-purple-light-med"
                          type="submit"
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            )}
          </Formik>
          {isLoading && <LoadingBlocker />}
        </div>
      </div>
    </div>
  )
}

export default ChallengeView
